import {apiAxios} from '@/router/auth'
import store, {toast} from '@/store'

export default {
  state: {
    group: null
  },
  getters: {},
  actions: {
    fetchGroup ({commit}, group_id) {
      return new Promise((resolve, reject) => {
        apiAxios.get(`/groups/${group_id}`).then(response => {
          commit('setGroup', response.data)
          resolve()
        }).catch(e => {
          console.log(e)
          reject(e.response)
        })
      })
    }
  },
  mutations: {
    setGroup (state, group) {
      state.group = group
    },
  }
}
